
<div class="to-dialog-title">
  <div>{{currentItem.name}}</div>
  <button mat-icon-button (mousedown)="cancel()">
    <mat-icon aria-label="Close Dialog">close</mat-icon>
  </button>
</div>

<!--START BODY-->
<div class="to-dialog-content">
  @if (currentItem.description?.length > 15) {
    <div class="offer-description">
      {{currentItem.description}}
    </div>
  }
  @for (group of currentItem.modifierGroups | filterBy:{'_visible':true,'_prepared':true, singleSelection:true}; track group) {
    <app-modifier-group [viewItem]="data.viewItem" [currentItem]="currentItem" [workMode]="'item'" [group]="group"></app-modifier-group>
  }
  @for (group of currentItem.modifierGroups | filterBy:{'_visible':true, singleSelection:false}; track group) {
    <app-modifier-group [viewItem]="data.viewItem" [currentItem]="currentItem" [workMode]="'item'" [group]="group"></app-modifier-group>
  }
</div>
<!--END BODY-->
<div class="to-dialog-actions">
  @if (data.enableClearItem) {
    <button mat-stroked-button type="button" (mousedown)="clearSelection()">
      {{'TD.clear_selection' | translate}}
    </button>
  }
  @else {
  <button mat-stroked-button (mousedown)="cancel()">
    {{'TD.cancel' | translate}}
  </button>
}
<button mat-flat-button color="accent" (mousedown)="submit()" class="rounded" style="min-width: 140px;">
  <div class="d-flex justify-content-between align-items-center">
    <span>{{(args.isEditSGItem ? 'TD.to-update' : 'TD.to-add') | translate}}</span>
    @if (args.currentItemPrice || currentItem.total) {
      <span class="ms-3">
        +{{ (currentItem.total + args.currentItemPrice) | lcurrency }}
      </span>
    }
  </div>
</button>
</div>


